import { useMyUsage } from "../../api/companies";
import { UsageBar } from "../../components/UsageBar";
import { ExternalLink } from "lucide-react";

export function UsagePage() {
  const { data } = useMyUsage();
  const u = data?.data;

  return (
    <div>
      <h2 className="mb-4 text-lg font-semibold text-gray-900 dark:text-white">Resource Usage</h2>

      {u && (
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
          {/* Tier info */}
          <div className="rounded-lg border border-gray-200 bg-white dark:border-riot-navy-700 dark:bg-riot-navy-800 p-5">
            <h3 className="mb-3 text-sm font-semibold text-gray-900 dark:text-white">Current Plan</h3>
            <div className="rounded-md border border-gray-100 bg-gray-50 px-4 py-3">
              <div className="flex items-center gap-1.5">
                <span className="text-2xl font-bold capitalize text-gray-900 dark:text-white">{u.subscriptionTier}</span>
                <ExternalLink size={14} className="text-gray-400 dark:text-riot-navy-400" />
              </div>
              <p className="mt-1 text-xs text-gray-400 dark:text-riot-navy-400">
                {u.subscriptionTier === "basic" && "Essentials for remote device update"}
                {u.subscriptionTier === "standard" && "Advanced automation and integration"}
                {u.subscriptionTier === "premium" && "Enterprise scaling and early access"}
              </p>
            </div>
          </div>

          {/* Usage bars */}
          <div className="col-span-2 rounded-lg border border-gray-200 bg-white dark:border-riot-navy-700 dark:bg-riot-navy-800 p-5">
            <h3 className="mb-4 text-sm font-semibold text-gray-900 dark:text-white">Resource Limits</h3>
            <div className="space-y-4">
              <UsageBar label="Devices" current={u.devices.current} limit={u.devices.limit} />
              <UsageBar label="Users" current={u.users.current} limit={u.users.limit} />
              <UsageBar label="Firmware Versions" current={u.firmware.current} limit={u.firmware.limit} />
              <UsageBar label="Device Groups" current={u.deviceGroups.current} limit={u.deviceGroups.limit} />
              <UsageBar label="Concurrent Tasks" current={u.concurrentTasks.current} limit={u.concurrentTasks.limit} />
            </div>
          </div>
        </div>
      )}

      {!u && <div className="py-20 text-center text-sm text-gray-400 dark:text-riot-navy-400">Loading usage data...</div>}
    </div>
  );
}
